import { HStack, Link, Table, Text } from "@chakra-ui/react";
import { LabelledEventIcon } from "@/components/EventIcon";
import { route } from "nextjs-routes";
import WcaFlag from "@/components/WcaFlag";
import CountryMap from "@/components/CountryMap";
import { components } from "@/types/openapi";
import { TFunction } from "i18next";

export default function CompetitorTable({
  eventIds,
  registrations,
  t,
  setPsychSheetEvent,
  linkToLive = false,
  competitionId,
}: {
  eventIds: string[];
  registrations: components["schemas"]["RegistrationDataV2"][];
  setPsychSheetEvent: (eventId: string) => void;
  t: TFunction;
  linkToLive?: boolean;
  competitionId: string;
}) {
  return (
    <Table.ScrollArea>
      <Table.Root width="100%">
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeader>Name</Table.ColumnHeader>
            <Table.ColumnHeader>Representing</Table.ColumnHeader>
            {eventIds.map((eventId) => (
              <Table.ColumnHeader
                key={eventId}
                onClick={() => setPsychSheetEvent(eventId)}
                cursor="pointer"
                _hover={{ bg: "grey.solid", color: "wcawhite.contrast" }}
              >
                <LabelledEventIcon eventId={eventId} />
              </Table.ColumnHeader>
            ))}
            <Table.ColumnHeader>Total</Table.ColumnHeader>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {registrations
            .toSorted((a, b) => a.user.name.localeCompare(b.user.name))
            .map((registration) => (
              <Table.Row key={registration.id}>
                {linkToLive ? (
                  <Table.Cell>
                    <Link
                      href={route({
                        pathname:
                          "/competitions/[competitionId]/live/competitors/[registrationId]",
                        query: {
                          registrationId: registration.id.toString(),
                          competitionId: competitionId,
                        },
                      })}
                    >
                      <Text fontWeight="medium">{registration.user.name}</Text>
                    </Link>
                  </Table.Cell>
                ) : (
                  <Table.Cell>
                    {registration.user.wca_id ? (
                      <Link
                        href={route({
                          pathname: "/persons/[wcaId]",
                          query: { wcaId: registration.user.wca_id },
                        })}
                      >
                        <Text fontWeight="medium">
                          {registration.user.name}
                        </Text>
                      </Link>
                    ) : (
                      <Text fontWeight="medium">{registration.user.name}</Text>
                    )}
                  </Table.Cell>
                )}
                <Table.Cell>
                  <HStack>
                    <WcaFlag code={registration.user.country_iso2} size="sm" />
                    <CountryMap
                      code={registration.user.country_iso2}
                      t={t}
                      fontWeight="bold"
                    />
                  </HStack>
                </Table.Cell>

                {eventIds.map((eventId) => (
                  <Table.Cell key={eventId}>
                    {registration.competing.event_ids.includes(eventId) ? (
                      <LabelledEventIcon eventId={eventId} />
                    ) : null}
                  </Table.Cell>
                ))}
                <Table.Cell>
                  {registration.competing.event_ids.length}
                </Table.Cell>
              </Table.Row>
            ))}
        </Table.Body>
      </Table.Root>
    </Table.ScrollArea>
  );
}
